import {sectionsByKey} from "./settings";


const data = {
    "CD": [
        'Enhance existing outdoor gathering areas (e.g. seating, shade)',
        'Improve outdoor recreation space',
        'Provide new outdoor spaces by building taller new buildings',
        'Seismically retrofit existing buildings',
        'Improve signage and wayfinding',
    ],
    "LC": [
        'Add indoor recreation and wellness space',
        'Build more housing',
        'Renovate existing housing',
        'Improve intercollegiate athletics venues',
        'Add more meeting / event / social space',
        'Provide more retail dining options throughout campus',
    ],
    "AC": [
        'Renovate existing academic and research buildings',
        'Add more active learning classrooms',
        'Add research space',
        'Add more collaboration and group study space',
        'Add more individual study space',

    ],
    "GA": [
        'Safer bicycling connections to/through campus',
        'Improve pedestrian connections',
        'Provide more vehicular parking',
        'Invest in shuttles / bikes / carpooling / other non-driving transportation programs',
        'Remove private vehicle circulation from the Campus Park (other than service, emergency, ADA vehicles)',
    ],
    "EWC": [
        'Upgrade the cogeneration plant to reduce emissions',
        'Renovate existing buildings to reduce environmental footprint',
        'Add facilities to reuse / recapture water',
        'Add green stormwater infrastructure and restore natural systems',
    ]
};

const programElements = [];
Object.keys(data).forEach((k) => {
    const section = sectionsByKey[k];
    if (!section) return;
    const values = data[k];
    programElements.push({
        name: section.title,
        color: section.color,
        elements: values.map((v, i) => {
            return {id: `${k}_${i + 1}`, name: v}
        })
    });
});
export default programElements;
